import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function BestSellers() {
    const [prods, setProds] = useState([]);
    useEffect(() => {
        api.get("/bestsellers").then((r) => setProds(r.data));
    }, []);

    return (
        <div
            className="max-w-[1440px] mx-auto px-6 md:px-12 pt-16 pb-32"
            data-testid="best-sellers-page"
        >
            <div className="overline mb-4">Most loved</div>
            <h1
                className="font-serif text-5xl sm:text-6xl tracking-tight mb-6"
                style={{ color: "var(--vl-text)" }}
                data-testid="best-sellers-title"
            >
                Our{" "}
                <em
                    style={{
                        color: "var(--vl-rose)",
                        fontStyle: "italic",
                    }}
                >
                    best sellers.
                </em>
            </h1>
            <p
                className="max-w-xl mb-14"
                style={{
                    color: "var(--vl-muted)",
                    lineHeight: 1.8,
                }}
            >
                A quietly-voted shortlist — the pieces our community returns
                to again and again.
            </p>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                {prods.map((p, i) => (
                    <ProductCard key={p.id} product={p} index={i} />
                ))}
            </div>
        </div>
    );
}
